import { useUserContext } from 'src/contexts/UserContext';
import {
  SELLER_USER_DENY_LIST,
  ALLOWED_SELLER_USER_ROUTES,
} from 'src/modules/Auth/sellerUserDenyList';
import { Redirect, Route } from 'react-router-dom';

function PrivateRoute({ children, path, ...rest }) {
  const { auth, loading, userEmail } = useUserContext();

  if (loading) {
    return null;
  }

  if (!auth) {
    return (
      <Route {...rest}>
        <Redirect to="/login" />
      </Route>
    );
  }

  if (
    SELLER_USER_DENY_LIST.includes(userEmail) &&
    !ALLOWED_SELLER_USER_ROUTES.some(pattern => pattern.test(path))
  ) {
    return (
      <Route {...rest}>
        <Redirect to="/" />
      </Route>
    );
  }

  return <Route {...rest}>{children}</Route>;
}

export default PrivateRoute;
